//	Default color definitions

const primaryBlue = '#3e8cbb';
const primaryBlueHover = '#48a1d9';

const brandPrimary = '#5d86a0';

const linkColor = brandPrimary;
const linkHoverColor = '#5D86A0';

const linkNaviGrey = '#555';

const textStandard = '#222';
const white = '#F5F5F5';
const black = '#222';
const pureWhite = '#fff';
const pureBlack = '#000';

export default {
  primaryBlue,
  primaryBlueHover,
  linkColor,
  linkHoverColor,
  linkNaviGrey,
  textStandard,
  white,
  black,
  pureWhite,
  pureBlack,
};
